(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/hooks/use-debugger.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/hooks/use-debugger.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const useDebugger = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDebugger = _useState2[0],
    setShowDebugger = _useState2[1];
  const handleParamLogic = debugParamValue => {
    setShowDebugger(true);
    if (debugParamValue === 'false') {
      svs.utils.paramHandler.remove({
        key: 'debuga'
      });
      svs.core.deviceSession.remove('lyckoplatsenDebug');
      setShowDebugger(false);
    } else if (!debugParamValue) {
      svs.utils.paramHandler.set({
        key: 'debuga',
        value: 'true'
      });
    }
  };
  useEffect(() => {
    const debugParamValue = svs.utils.paramHandler.get({
      key: 'debuga'
    }).value;
    svs.core.deviceSession.get('lyckoplatsenDebug', undefined, result => {
      if (result || debugParamValue === 'true') {
        handleParamLogic(debugParamValue);
        if (!result) {
          svs.core.deviceSession.set('lyckoplatsenDebug', undefined, true);
        }
      }
    });
  }, []);
  return showDebugger;
};
Object.assign(svs.lyckoplatsen.hooks, {
  useDebugger
});

 })(window);